import { render, staticRenderFns } from "./Insync.vue?vue&type=template&id=fc5ecca0&scoped=true"
import script from "./Insync.vue?vue&type=script&lang=js"
export * from "./Insync.vue?vue&type=script&lang=js"
import style0 from "./Insync.vue?vue&type=style&index=0&id=fc5ecca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5ecca0",
  null
  
)

export default component.exports